import {useEffect, useId, useState} from "react";
import {ThinArrowLeft, ThinCloseIcon, TomansIcon} from "../../../components/icons/material-icons";
import {useNavigate} from "react-router-dom";
import {CurrencyFormat, NumberToPersianLetters, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";

export const AdminPayTuitionModal = (props: {
    active: boolean,
    closeHandler: any,
    studentId: string,
    price: number,
    paidSoFar: number,
    totalPrice: number,
    min: number
}) => {
    const [price, setPrice] = useState('1000000');
    const [priceErr, setPriceErr] = useState(''); // error message in persian, '' => no errors
    const priceId = useId();
    useEffect(() => {
        const isActive = props.active;
        const suggested = props.price;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setPrice(suggested === 0 ? '' : suggested.toString());
            setPriceErr('');
            setInvoice({
               show: false,
               nd: '',
               url: '',
            });
        } else {
            document.body.classList.remove("body-no-scroll");
        }
    }, [props.active]);
    const generateInvoice = () => {
        const _price = price;
        if (_price === '' || _price === 'NaN') {
            setPriceErr('لطفا مبلغ را وارد کنید.');
            return;
        }
        const priceInt = parseInt(_price);
        if ((priceInt + props.paidSoFar) > props.totalPrice) {
            ShowSnackbar('مبلغ وارد شده بیش از شهریه تعیین شده است.','باشه',5000);
            return;
        }
        // if (priceInt < props.min) {
        //     ShowSnackbar(`حداقل مبلغ پرداختی ${CurrencyFormat(props.min)} تومان می‌باشد.`,'باشه',5000);
        //     return;
        // }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/tuition/generate-invoice',
            {
                p: priceInt.toString(),
                studentId:props.studentId.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                nd: string,
                min:number,
                url: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    else if(d.reason === 'min')
                            ShowSnackbar(`حداقل مبلغ پرداختی ${CurrencyFormat(d.min)} تومان می‌باشد.`,'باشه',5000);
                    else if(d.reason === 'too-much')
                        ShowSnackbar('مبلغ وارد شده بیش از شهریه تعیین شده است.','باشه',5000);
                    return;
                }
                ShowSnackbar('لطفا فاکتور ایجاد شده را پرداخت کنید.', 'باشه', 5000);
                setInvoice({
                    show: true,
                    url: d.url,
                    nd: d.nd,
                });
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [invoice, setInvoice] = useState({
        show: false,
        nd: '',
        url: '',
    });
    const launchPayScreen = () => {
        const _invoice = {...invoice};
        ShowProgressLoading();
        window.location.href = _invoice.url;
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div>
                        <b>پرداخت قسط شهریه</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    {
                        !invoice.show ?
                            <div className="pay-tuition-modal">
                                <label htmlFor={priceId}>مبلغی که می‌خواهید پرداخت کنید:</label>
                                <input type="number"
                                       className={"form-control text-center" + (priceErr === '' ? '' : ' is-invalid')}
                                       value={price}
                                       // min={props.min}
                                       onChange={e => {
                                           const t = e.currentTarget.value;
                                           setPrice(t);
                                           setPriceErr('');
                                       }}
                                       onKeyUp={e => {
                                           if (e.which === 13)
                                               generateInvoice();
                                       }}
                                />
                                {
                                    price !== '' ?
                                        <span style={{
                                            display: 'block',
                                            margin: '5px 0 0 0',
                                            fontWeight: 400,
                                            color: '#0a53be'
                                        }}>
                                       {NumberToPersianLetters(parseInt(price)) + " تومان"}
                                   </span> : null
                                }
                                <div
                                    className={"invalid-feedback " + (priceErr === '' ? 'd-none' : 'd-block')}>{priceErr}</div>
                                <div className="d-flex justify-content-end align-items-center"
                                     style={{gap: 10, marginTop: 30}}>
                                    <button className="cancel-button" onClick={props.closeHandler}>
                                        <b>انصراف</b>
                                    </button>
                                    <button className="btn-pay" onClick={generateInvoice}>
                                        <b>ادامه پرداخت</b>
                                    </button>
                                </div>
                            </div> :
                            <div style={{padding: '20px 5px 5px 5px'}}>
                                <div className="tuition-invoice-preview">
                                    <i>
                                        <span>{StringDigitsConvertToPersian(CurrencyFormat(price))}</span>
                                        <TomansIcon/>
                                    </i>
                                </div>
                                <div style={{height: 30}}/>
                                <div className="info-tile">
                                    <b>کد فاکتور:</b>
                                    <span>{invoice.nd.toUpperCase()}</span>
                                </div>
                                <div className="info-tile">
                                    <b>موضوع فاکتور:</b>
                                    <span>پرداخت شهریه</span>
                                </div>
                                <div className="info-tile">
                                    <b>نحوه پرداخت:</b>
                                    <span>پرداخت آنلاین</span>
                                </div>
                                <div style={{height: 20}}/>
                                <div className="d-flex justify-content-end align-items-center">
                                    <button className="btn-pay" onClick={launchPayScreen}>
                                        <b>پرداخت آنلاین</b>
                                        <ThinArrowLeft/>
                                    </button>
                                </div>
                            </div>
                    }
                </div>
            </div>
        </>
    );
};